import { useMutation } from '@tanstack/react-query';

import { api } from '../../../config/ApiConfig';
import { AuthData } from '../../../providers/AuthUserProvider';

type LoginInput = {
  email: string;
  password: string;
  rememberMe?: boolean;
};

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: (input: LoginInput) =>
      api
        .post<AuthData>('/v1/auth/login', input)
        .then((response) => response.data),
    meta: {
      errorToastFallback: 'Email ou senha inválidos',
    },
  });
};
